document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href^="#"]');
  if(a){
    const id = a.getAttribute('href');
    const el = document.querySelector(id);
    if(el){ e.preventDefault(); el.scrollIntoView({behavior:'smooth', block:'start'}); }
  }
  const t = e.target.closest('[data-thumb]');
  if(t){
    const main = document.querySelector('[data-main-image]');
    const src = t.getAttribute('data-src');
    if(main && src){ main.src = src; }
  }
});

const sticky = () => {
  const bar = document.querySelector('[data-sticky-atc]');
  const hero = document.querySelector('[data-hero-end]');
  if(!bar || !hero) return;
  const rect = hero.getBoundingClientRect();
  bar.style.display = (rect.bottom < 0) ? 'block' : 'none';
};
window.addEventListener('scroll', sticky, {passive:true});
window.addEventListener('load', sticky);
